import { evaluateUserPreferenceAgainstPolicy } from "../utils/policy-evaluation";
import { useOrganizationCloudRenderingPolicies } from "./useOrganizationCloudRenderingPolicies";
import { useUserPreferencesQuery } from "./useUserPreferences";

export function useUseXRGatewaySettingQuery() {
  const { data: policies, isSuccess } = useOrganizationCloudRenderingPolicies();
  return useUserPreferencesQuery({
    enabled: isSuccess,
    select: (data) => {
      if (!data || !policies) {
        return false;
      }

      return evaluateUserPreferenceAgainstPolicy({
        userPreference: data.useXRGateway,
        policy: policies.xrGatewayPolicy,
        enforcedValue: true,
        disallowedValue: false,
        defaultValue: false,
      });
    },
  });
}
